import * as React from 'react';
import * as _ from 'lodash';
import Button from '../../../utils/common_components/tooltipButton';
import IconButton from '../../../utils/common_components/tooltipIconButton';
import TooltipWrapper from '../../../utils/common_components/tooltipWrapper';
import PanelGroup from '../../../vendor/react-panelgroup/panelgroup';
import FontIcon from 'react-toolbox/lib/font_icon';
export default function () {
    function repeatExercise1(exercise, exerciseIndex) {
        return React.createElement('div', {
            'className': 'width-150 box-shadow bg-white m-l-10 m-r-10 m-t-10 ribbon-container',
            'key': 'exercise' + exercise.id
        }, React.createElement('div', {
            'className': 'thumbnail box-150-90',
            'style': { backgroundImage: 'url(' + encodeURI(exercise.exercise_thumbnail_url) + ')' }
        }), React.createElement('div', {
            'className': 'row bg-white center-xs middle-xs m-0 m-t-8 p-l-5',
            'style': { height: '30px' }
        }, React.createElement(TooltipWrapper, {
            'className': 'col-xs-' + (exercise.description ? '9' : '12') + ' f-16 truncate',
            'tooltip': exercise.name
        }, '\n                                ', exercise.name, '\n                            '), exercise.description ? React.createElement(IconButton, {
            'className': 'col-xs-2 c-black center-xs',
            'tooltip': exercise.description,
            'icon': 'info',
            'key': '2087'
        }) : null), React.createElement('div', { 'className': 'row center-xs m-0' }, React.createElement('div', { 'className': 'col-xs-12 p-b-2 m-0' }, React.createElement(Button, {
            'tooltip': 'Delete',
            'icon': 'delete_forever',
            'floating': true,
            'mini': true,
            'className': 'bg-danger micro',
            'onClick': () => {
                this.removeExercise(exercise);
            }
        }))));
    }
    function repeatExercise2(exercise, exerciseIndex) {
        return [!exercise.is_client_specific && !(exercise.id in this.props.partner_exercises_ids) ? React.createElement('div', {
                'className': 'width-150 box-shadow bg-white m-l-10 m-r-10 m-t-10 ribbon-container',
                'key': '41141'
            }, React.createElement('div', {
                'className': 'thumbnail box-150-90',
                'style': { backgroundImage: 'url(' + encodeURI(exercise.exercise_thumbnail_url) + ')' }
            }), React.createElement('div', {
                'className': 'row bg-white center-xs middle-xs m-0 m-t-8 p-l-5',
                'style': { height: '30px' }
            }, React.createElement(TooltipWrapper, {
                'className': 'col-xs-' + (exercise.description ? '9' : '12') + ' f-16 truncate',
                'tooltip': exercise.name
            }, '\n                                    ', exercise.name, '\n                                '), exercise.description ? React.createElement(IconButton, {
                'className': 'col-xs-2 c-black center-xs',
                'tooltip': exercise.description,
                'icon': 'info',
                'key': '4909'
            }) : null), React.createElement('div', { 'className': 'row center-xs m-0' }, React.createElement('div', { 'className': 'col-xs-12 p-b-2 m-0' }, React.createElement(Button, {
                'tooltip': 'Add',
                'icon': 'add',
                'floating': true,
                'mini': true,
                'className': 'bg-success micro',
                'onClick': () => {
                    this.addExercise(exercise);
                }
            })))) : null];
    }
    return React.createElement('div', { 'className': 'row start-xs  m-t-20 m-l-20 custom-divider' }, React.createElement('h3', { 'className': 'text-center m-5' }, '\n        Shared content library \'', this.props.partner_library.name, '\'\n    '), React.createElement(PanelGroup, { 'borderColor': '#eee' }, React.createElement('div', { 'className': 'col-xs-12 full-height' }, React.createElement('div', { 'className': 'row start-xs' }, React.createElement('div', { 'className': 'col-xs-6' }, React.createElement('h5', { 'className': 'm-b-15' }, 'Shared Exercises')), React.createElement('div', { 'className': 'col-xs-6 end-xs' }, React.createElement(Button, {
        'tooltip': 'Remove all exercises from this shared content library',
        'label': 'REMOVE ALL',
        'className': 'bg-danger small-button c-white',
        'onClick': () => {
            this.removeAllExercises();
        }
    }))), React.createElement.apply(this, [
        'div',
        { 'className': 'row start-xs m-10' },
        _.map(this.props.partner_library.exercises, repeatExercise1.bind(this))
    ]), this.props.partner_library.paginate_info.page < this.props.partner_library.paginate_info.total_pages - 1 ? React.createElement('div', {
        'className': 'row center-xs m-30 w-100',
        'key': '2867'
    }, React.createElement('div', { 'className': 'col-xs-12' }, React.createElement(Button, {
        'label': 'Load more exercises...',
        'className': 'bg-primary c-black',
        'onClick': () => {
            this.loadMoreLibraryExercises(true);
        }
    }))) : null), React.createElement('div', {
        'className': 'col-xs-12',
        'style': { minHeight: '400px' }
    }, React.createElement('div', { 'className': 'row start-xs' }, React.createElement('div', { 'className': 'col-xs-6' }, React.createElement('h5', { 'className': 'm-b-15' }, 'Exercises you can share')), React.createElement('div', { 'className': 'col-xs-6 end-xs' }, React.createElement(Button, {
        'tooltip': 'Add all exercises to this shared content library',
        'label': 'ADD ALL',
        'className': 'bg-success small-button c-white',
        'onClick': () => {
            this.addAllExercises();
        }
    }))), React.createElement.apply(this, [
        'div',
        { 'className': 'row start-xs m-10' },
        _.map(this.props.exerciseList, repeatExercise2.bind(this))
    ]), this.props.paginateInfo.page < this.props.paginateInfo.total_pages - 1 ? React.createElement('div', {
        'className': 'row center-xs m-30 w-100',
        'key': '5795'
    }, React.createElement('div', { 'className': 'col-xs-12' }, React.createElement(Button, {
        'label': 'Load more exercises...',
        'className': 'bg-primary c-black',
        'onClick': () => {
            this.loadMoreAllExercises(true);
        }
    }))) : null)));
}